import { Map } from 'immutable';

import * as types from './constants';

const initialState = Map({
  count: 0
});

const counterReducer = (state = initialState, action) => {

  switch (action.type) {
    case types.INCREMENT_VALUE:

      return state
        .set('count', state.get('count') + 1);
    case types.DECREMENT_VALUE:

      return state
        .set('count', state.get('count') - 1);
    default:
      return state;
  }
};

export default counterReducer;



// WEBPACK FOOTER //
// ./src/containers/CounterPage/reducer.js